import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { I18nProvider } from "@/i18n";
import SeoManager from "@/components/site/SeoManager";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import TrustBand from "@/components/site/TrustBand";
import Stats from "@/components/site/Stats";
import Services from "@/components/site/Services";
import Solutions from "@/components/site/Solutions";
import Etapes from "@/components/site/Etapes";
import Consultant from "@/components/site/Consultant";
import Calculator from "@/components/site/Calculator";
import Faq from "@/components/site/Faq";
import MarqueeBand from "@/components/site/MarqueeBand";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingCall from "@/components/site/FloatingCall";
import ImpactBlock from "@/components/site/ImpactBlock";
import ImpactSocial from "@/pages/ImpactSocial";
import { captureUtm } from "@/components/site/applyUrl";

const HomePage = () => (
  <main>
    <Hero />
    <TrustBand />
    <Stats />
    <MarqueeBand />
    <Services />
    <Solutions />
    <Etapes />
    <Consultant />
    <Calculator />
    <Faq />
    <ImpactBlock />
    <Contact />
  </main>
);

function App() {
  useEffect(() => {
    captureUtm();
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <I18nProvider>
      <BrowserRouter>
        <SeoManager />
        <div className="min-h-screen" style={{ background: "#0F2027" }}>
          <div className="noise-overlay" />
          <Toaster position="top-center" richColors />
          <Nav />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/impact-social" element={<ImpactSocial />} />
          </Routes>
          <Footer />
          <FloatingCall />
        </div>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
